import React, { useState, useEffect, use } from "react";
import { pendingApprovalFiles, approveDocument, deActivateDocument } from "../../services/dms/dms-admin";
import DocumentIcon from '../../assets/Approval_folder.svg';
import ModalComponent from '../common/ModalComponent/ModalComponent';
import { NoDataContainer } from '../../styles/common.styles';
import Loader from "../common/Loader/Loader";
import validateFields from "../../utils/ValidationInput";
import onClickViewDoc from "./ViewDocument";
import { DataTableComponent } from "../common/TableComponent/DataTableComponent";
import { useTranslation } from "react-i18next";

const PendingApprovalDocument = ({ userId, pendingStateSender, isBackClicked }) => {
  const { t, i18n } = useTranslation();
  const columns1 = [
    { name: t("documentTitle"), field: "title", selector: (row) => row.title, sortable: true },
    { name: t("documentType"), field: "documentType", selector: (row) => row.documentType, sortable: true },
    { name: t("subDocumentType"), field: "documentSubType", selector: (row) => row.documentSubType, sortable: true },
    { name: t("owner"), field: "owner", selector: (row) => row.owner, sortable: true },
    { name: t("status"), field: "status", selector: (row) => row.status, sortable: true, width: '200px' },
    { name: t("approverEmail"), field: "workFlowApproverEmail", selector: (row) => row.workFlowApproverEmail, sortable: true, width: '200px' },
  ];

  const RejectComments = [
    {
      fieldName: t("rejectComments"),
      name: "RejectComment",
      fieldValue: "",
      type: "textarea",
      placeholder: t("enterYourCommentsHere"),
      required: true
    }
  ];

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [searchVal, setSearchVal] = useState({ name: "", language: "" });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rowData, setRowData] = useState({});
  const [actionStatus, setActionStatus] = useState('');
  const [formData, setFormData] = useState({
    RejectComment: ""
  });
  const [isPendingDocumentClicked, setIsPendingDocumentClicked] = useState(false);
  const [isPendingDocsViewActive, setIsPendingDocsViewActive] = useState(false);  
  const lang = i18n.language || "en";

  useEffect(() => {
    if (!isBackClicked) {
      setTableData([]);
      }
      if(isBackClicked && isPendingDocumentClicked){
        setIsPendingDocumentClicked(false);
      }
  }, [isBackClicked]);

  useEffect(() => {
    
    if (isBackClicked && isPendingDocsViewActive) {
       handleFolderClick();
    }
  }, [i18n.language, isPendingDocsViewActive]);

  const handleFolderClick = async () => {
    setLoading(true);
    pendingStateSender(true);
    setIsPendingDocumentClicked(true);
    setIsPendingDocsViewActive(true);
    try {
      const result = await pendingApprovalFiles(userId || 254);
      const resultData = result.data
            ?.map(item => {
                let displayName = "";
                let documentTypeDisplay = "";
                let documentSubTypeDisplay = "";
                if (lang === "jp" && item.title_JP && item.documentType_JP && item.documentSubType_JP ) {
                    displayName = item.title_JP;
                    documentTypeDisplay = item.documentType_JP;
                    documentSubTypeDisplay = item.documentSubType_JP
                } else if (lang === "ch" && item.title_CH && item.documentType_CH) {
                    displayName = item.title_CH;
                    documentTypeDisplay = item.documentType_CH;
                    documentSubTypeDisplay = item.documentSubType_CH
                } else if (lang === "en") {
                    displayName = item.title;
                    documentTypeDisplay = item.documentType;
                    documentSubTypeDisplay = item.documentSubType
                }
                return {
                    ...item,
                    title: displayName,
                    documentType: documentTypeDisplay,
                    documentSubType: documentSubTypeDisplay,
                    
                };
            })?.filter(item => item.title && item.title.trim() !== "");

      if (result?.data?.length > 0) {
        setTableData(resultData);
      } else {
        setTableData([]);
      }
    } catch (error) {
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };

  const onViewDoc = async (row, rowIndex) => {
    onClickViewDoc(row);
  };

  const onDownloadDoc = async (row) => {
    // Placeholder for download functionality
  };

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setSearchVal((prev) => ({ ...prev, [name]: value }));
  };

  const handleApprove = (row, rowIndex, status) => {
    setActionStatus(status);
    setRowData(row);
    setIsModalOpen(true);
  };

  const handleReject = (row, rowIndex, status) => {
    setActionStatus(status);
    setRowData(row);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setFormData({ RejectComment: "" });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      if (actionStatus === 'approve') {
        await approveDocument(rowData.documentId, rowData);
      } else {
        const requiredFields = [
          { label: t("rejectComment"), key: "RejectComment", type: "text" }
        ];
        const isValid = validateFields(formData, requiredFields, '', 256);
        if (!isValid) {
          setLoading(false);
          return;
        }
        await deActivateDocument(rowData, formData.RejectComment);
        setFormData({ RejectComment: "" });
      }
      const result = await pendingApprovalFiles(userId || 254);
      setTableData(result.data);
      setIsModalOpen(false);
      setLoading(false);
    } catch (error) {
      setIsModalOpen(true);
      setLoading(false);
    }
  };

  const onChangeInput = (inputData) => {
    const { name, value } = inputData;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const renderTableContent = () => {
    if (loading) return <div>{t("loading")}</div>;
    if (tableData?.length > 0) {
      return (
        <div className="glbOuterWrapper">
          <DataTableComponent
            columns={columns1}
            data={tableData}
            onEditDetails={""}
            tableName="PendingApprovalDocuments"
            onDownloadDoc={onDownloadDoc}
            onViewDoc={onViewDoc}
            handleApprove={handleApprove}
            handleReject={handleReject}
            pageCount={5}
          />
        </div>
      );
    } else if (!loading && tableData?.length === 0 && !isBackClicked) {
      return (
        <div
          className="folder"
          onClick={handleFolderClick}
        >
          <img src={DocumentIcon} alt="folder" className="folder-icon" />
          <p>{t("pendingApprovalDocuments")}</p>
        </div>
      );
    } else {
      return (
        <NoDataContainer>
          <h1>
            {t("noDocumentsToApprove")}
          </h1>
        </NoDataContainer>
      );
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div
        className="Doc-container"
        style={{ width: (tableData?.length === 0 && !isBackClicked) ? "auto" : "100%" }}
      >
        {renderTableContent()}
        <ModalComponent
          modalTitle={actionStatus === 'approve' ? t("approveDocument") : t("rejectDocument")}
          isOpen={isModalOpen}
          modalText={actionStatus === 'approve' ? t("clickToSubmitApprove") : t("clickToSubmitReject")}
          modalType={t("approveDocument")}
          onClose={closeModal}
          fieldsData={actionStatus !== 'approve' && RejectComments}
          formData={formData}
          onChangeInput={onChangeInput}
          buttons={[
            <button className="saveButton" onClick={handleSubmit}>
              {t("submit")}
            </button>,
            <button className="cancelButton" onClick={closeModal}>
              {t("cancel")}
            </button>,
          ]}
        />
      </div>
    </>
  );
};

export default PendingApprovalDocument;
